import { IndexPage } from './IndexPage';
import { DetailPage } from './DetailPage';
import { BuildInformation } from './DetailPage';
import { BuildDetailPage } from './BuildDetailpage';
import { GameBuildListPage } from './GameBuildList';

export {
IndexPage,
DetailPage,
BuildInformation,
BuildDetailPage,
GameBuildListPage,
}


/** WEBPACK FOOTER **
 ** ./Typescript/Pages/Games/index.ts
 **/